import { Dayjs } from "dayjs";

import { useMemo } from "react";

import useThemeData from "./useThemeData";

const useDatePickerStyle = (value: [Dayjs | null, Dayjs | null]) => {
  const { isDarkMode } = useThemeData();

  const paperStyle = useMemo(() => {
    let color = "";

    if (isDarkMode) {
      color = "";
    } else {
      color = value[0] || value[1] ? "#1976d2" : "";
    }

    return {
      sx: {
        "& .MuiDateRangePickerDay-notSelectedDate:not(.Mui-disabled)": {
          color,
        },
      },
    };
  }, [isDarkMode, value]);

  return {
    paperStyle,
  };
};

export default useDatePickerStyle;
